import type { TovVersionResponse } from "contracts/api/client-tov/version.responses";
import { For } from "solid-js";
import { TOV_FIELD_KIND } from "../../enums/tov";
import { type CardEditProps, EditableCard, type FieldSpec } from "./EditForms";
import { Group } from "./Group";
import { CardGrid, RangeBar } from "./primitives";

const TONE_FIELDS: FieldSpec[] = [
  { name: "key", label: "Key", kind: TOV_FIELD_KIND.TEXT },
  { name: "label", label: "Label", kind: TOV_FIELD_KIND.TEXT },
  { name: "lowLabel", label: "Low", kind: TOV_FIELD_KIND.TEXT },
  { name: "highLabel", label: "High", kind: TOV_FIELD_KIND.TEXT },
  { name: "targetMin", label: "Min", kind: TOV_FIELD_KIND.NUMBER },
  { name: "targetMax", label: "Max", kind: TOV_FIELD_KIND.NUMBER },
];

export function ToneCards(props: {
  version: TovVersionResponse;
  edit: CardEditProps;
}) {
  return (
    <Group
      title="Tone dimensions"
      empty={props.version.toneDimensions.length === 0}
    >
      <CardGrid>
        <For each={props.version.toneDimensions}>
          {(dimension) => (
            <EditableCard
              title={dimension.label}
              editable={props.edit.editable}
              fields={TONE_FIELDS}
              initial={{
                key: dimension.key,
                label: dimension.label,
                lowLabel: dimension.lowLabel,
                highLabel: dimension.highLabel,
                targetMin: dimension.targetMin,
                targetMax: dimension.targetMax,
                displayOrder: dimension.displayOrder,
              }}
              onSave={(values) =>
                props.edit.onEdit("tone-dimensions", dimension.id, values)
              }
              onDelete={() =>
                props.edit.onDelete("tone-dimensions", dimension.id)
              }
            >
              <RangeBar min={dimension.targetMin} max={dimension.targetMax} />
              <div class="tov-range-labels">
                <span>{dimension.lowLabel}</span>
                <span>{dimension.highLabel}</span>
              </div>
            </EditableCard>
          )}
        </For>
      </CardGrid>
    </Group>
  );
}
